import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { SECTION } from 'src/constants/section';
import type { ModulePermission } from 'src/types/modulePermission';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';

// Custom React hook to fetch and determine read-only follow-up permissions for current user
export const useFollowUpPermissions = () => {
  const endPoint = apiPaths.USER.FOLLOW_UP_PERMISSIONS;
  const {
    data: userCanEditFollowUps,
    isFetching,
    isLoading,
  } = useQuery<boolean, string>({
    queryKey: [endPoint],
    queryFn: () =>
      HttpService.get(endPoint)
        .then(({ data }: AxiosResponse<ModulePermission[]>) =>
          // Right now the endpoint only returns permissions for one module
          // the hook is already set up to handle multiple modules in the future
          data.some(
            (permission) =>
              permission.module.module_type === SECTION.FOLLOW_UP &&
              permission.read_only === false,
          ),
        )
        .catch(() => Promise.reject()),
  });
  const loading = isFetching || isLoading;

  return {
    userCanEditFollowUps,
    loading,
  };
};
